import { SortDirection } from '../../../../utils/constants';
import { createSearchPageSlice } from '../../../Generic/SearchPage/slices/searchPageSlice';
import { updateEndDate, updateStartDate } from '../../../../utils/dateTimeUtls';

export const filterFields = {
  BunkeringDateFrom: 'BunkeringDateFrom',
  BunkeringDateTo: 'BunkeringDateTo',
};

const initialFilterState = {
  BunkeringDateFrom: updateStartDate(new Date(new Date().setDate(new Date().getDate() - 10))).toISOString(),
  BunkeringDateTo: updateEndDate(new Date()).toISOString(),
};

const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'BunkeringDate',
  sortDirection: SortDirection.Desc,
};

export const sliceName = 'statisticSearch';
const statisticSearchSlice = createSearchPageSlice({
  sliceName,
  filterFields,
  initialFilterState,
  initialPageState,
});

export const statisticsSearchActions = statisticSearchSlice.actions;
export default statisticSearchSlice.reducer;
